<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 0 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <vertical-form-table v-model="form" v-bind="{ items }" class="mb-20 mb-lg-40">
                    <template slot="참여자">
                        <autocomplete-applications v-model="form.applications" :recruitment="form?.recruitment" />
                    </template>
                </vertical-form-table>
                <listed-datetime-picker v-model="form.schedulesAvailable" @input="form = { ...form }" />
                <meeting-schedules-card :meeting="form" class="mt-20 mt-lg-40" />
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="reset"><span class="grey-6--text">초기화</span></v-btn>
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false"><span class="grey-6--text">취소하기</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="save"><span>저장하기</span></v-btn>
            </div>
            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, initMeeting, MEETING_STATES } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import ListedDatetimePicker from "@/components/dumb/listed-datetime-picker.vue";
import AutocompleteApplications from "./autocomplete-applications.vue";
import MeetingSchedulesCard from "@/components/dumb/meeting-schedules-card.vue";

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        ListedDatetimePicker,
        AutocompleteApplications,
        MeetingSchedulesCard,
    },
    props: {
        value: { type: Object, default: initMeeting },
    },
    data: () => ({
        meeting: initMeeting(),
        form: initMeeting(),
        applications: [],

        attrs_input,

        shows: false,
        loading: false,
        className: Math.random().toString().slice(2),
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            return this.isCreate ? "미팅 생성하기" : "미팅 수정하기";
        },
        items() {
            const items = [
                {
                    key: "title",
                    term: "제목",
                    type: "text",
                },
                {
                    key: "state",
                    term: "상태",
                    type: "select",
                    items: Object.values(MEETING_STATES),
                    class: `meeting-view-state-${this.className}`,
                    menuProps: { attach: `.meeting-view-state-${this.className}` },
                },
                {
                    key: "recruitment.subject",
                    term: "채용공고",
                    type: "text",
                    disabled: true,
                },
                {
                    key: "applications",
                    term: "참여자",
                },
                {
                    key: "matching",
                    term: "매칭기간",
                    type: "dates",
                },
            ].map((item) => ({ ...attrs_input, ...item }));
            return items;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
        shows() {
            this.reset();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                if (this.isCreate) {
                    this.meeting = initMeeting(this.value);
                } else {
                    const { meeting } = await api.v1.company.meetings.get({
                        _id: this.value?._id,
                    });

                    if (meeting?.matching?.startsAt) meeting.matching.startsAt = meeting.matching.startsAt.toDate();
                    if (meeting?.matching?.endsAt) meeting.matching.endsAt = meeting.matching.endsAt.toDate();

                    this.meeting = initMeeting(meeting);
                }
            } finally {
                this.reset();
                this.loading = false;
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { applications = [], _id, title, state, matching } = this.form;

                let _applications = applications.map(({ _id }) => _id);
                let form = { _id, _applications, title, state, matching };
                if (!_id) delete form._id;

                const { post, put } = api.v1.company.meetings;
                const { meeting } = await (this.isCreate ? post : put)(form);
                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");

                if (this.isCreate) this.$router.go("/dashboard/meetings");

                this.$emit("input", meeting);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        reset() {
            this.form = JSON.parse(JSON.stringify(this.meeting));
        },
    },
};
</script>

<style></style>
